import Image from "next/image";
import interiorImage1 from "../public/img/about/interior1.jpg";
import interiorImage2 from "../public/img/about/interior2.jpg";
import interiorImage3 from "../public/img/about/interior3.jpg";
import { useRouter } from "next/router";
import localized from "../locale/locales";
import { useEffect, useRef } from "react";
import { moveImageBox } from "../helpers/animations";

export default function AboutHighlights() {
  const { locale } = useRouter();
  const { aboutUs: lang } = localized[locale];

  const refImage1 = useRef();
  const refImage2 = useRef();

  useEffect(() => {
    const handleScroll = () => {
      if (refImage1.current) {
        moveImageBox(refImage1, refImage2, -0.02, 0.05);
      }
    };

    window?.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window?.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="flex flex-col-reverse md:flex-row items-start">
      <div className="w-full flex-1 flex flex-col-reverse md:flex-col md:gap-24">
        <div className="pl-12 md:pl-0 pt-12 md:pr-20">
          <div className="max-w-[500px]">
            <div ref={refImage1}>
              {/* mobile third image */}
              <Image
                src={interiorImage1}
                className="rounded-tl-6 rounded-bl-6 md:rounded-tr-6 md:rounded-br-6"
                alt="Interiér Next.Move"
              />
            </div>
          </div>
        </div>

        <div className="pt-12 md:pt-0">
          <p
            className="text-sm leading-relaxed max-w-[42ch] px-6 md:px-0"
            dangerouslySetInnerHTML={{ __html: lang.introduction[1] }}
          />
        </div>

        <div className="pr-12 md:pr-0 -mt-8 md:mt-0 md:pl-20 flex md:justify-end">
          <div className="max-w-[280px] md:max-w-[370px] flex-1">
            {/* mobile second image */}
            <Image
              src={interiorImage2}
              className="rounded-tr-6 rounded-br-6 md:rounded-tl-6 md:rounded-bl-6"
              alt="Interiér Next.Move"
            />
          </div>
        </div>
      </div>

      <div className="flex-1 flex flex-col gap-16 md:gap-0 w-full">
        <p
          className="text-sm leading-relaxed max-w-[42ch] px-6 md:px-0"
          dangerouslySetInnerHTML={{ __html: lang.introduction[0] }}
        />

        <div className="w-full pl-20 flex justify-end">
          <div className="max-w-[500px] flex-1">
            <div ref={refImage2}>
              {/* mobile first image */}
              <Image
                src={interiorImage3}
                className="rounded-tl-6 rounded-bl-6 md:rounded-tr-6 md:rounded-br-6"
                alt="Interiér Next.Move"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
